export const translations = {
  he: {
    // Menu items
    home: "דף הבית",
    products: "מוצרים",
    storeProducts: "מוצרים",
    productSearch: "חיפוש מוצרים",
    categories: "קטגוריות",
    companies: "חברות",
    suppliers: "ספקים",
    promotions: "מבצעים",
    brochures: "ברושור מבצעים",
    promotionImplementation: "הטמעת מבצעים",
    recommendations: "המלצות הזמנה",
    mustOrder: "חובת הזמנה",
    newProducts: "מוצרים חדשים",
    slowMovingProducts: "מוצרים ללא תנועה",
    orders: "רשימת הזמנות",
    serviceRequests: "קריאות שירות",
    inventoryCount: "ספירת מלאי",
    manageInventoryCounts: "ניהול ספירות מלאי",
    safeCount: "ספירת כספות",
    safeCountAdmin: "ספירת כספות - ניהול",
    notifications: "הודעות",
    destructions: "השמדות",
    returns: "חזרות",
    chains: "רשתות",
    stores: "סופרים",
    users: "משתמשים",
    logout: "התנתק",
    
    // Common
    search: "חיפוש",
    filter: "סינון",
    save: "שמור",
    cancel: "ביטול",
    delete: "מחק",
    edit: "ערוך",
    add: "הוסף",
    back: "חזור",
    close: "סגור",
    yes: "כן",
    no: "לא",
    loading: "טוען...",
    error: "שגיאה",
    success: "הצלחה",
    
    // Greetings
    goodMorning: "בוקר טוב",
    goodAfternoon: "צהריים טובים",
    goodEvening: "ערב טוב",
    goodNight: "לילה טוב",
    
    // Days
    sunday: "ראשון",
    monday: "שני",
    tuesday: "שלישי",
    wednesday: "רביעי",
    thursday: "חמישי",
    friday: "שישי",
    saturday: "שבת",
    
    // Other
    allCategories: "כל הקטגוריות",
    systemAdmin: "מנהל מערכת ראשי",
    areaManager: "מנהל איזור",
    allNetworks: "כל הרשתות"
  },
  en: {
    // Menu items
    home: "Home",
    products: "Products",
    storeProducts: "Products",
    productSearch: "Product Search",
    categories: "Categories",
    companies: "Companies",
    suppliers: "Suppliers",
    promotions: "Promotions",
    brochures: "Promotions Brochure",
    promotionImplementation: "Promotion Implementation",
    recommendations: "Order Recommendations",
    mustOrder: "Must Order",
    newProducts: "New Products",
    slowMovingProducts: "Slow Moving Products",
    orders: "Orders List",
    serviceRequests: "Service Requests",
    inventoryCount: "Inventory Count",
    manageInventoryCounts: "Manage Inventory Counts",
    safeCount: "Safe Count",
    safeCountAdmin: "Safe Count - Management",
    notifications: "Notifications",
    destructions: "Destructions",
    returns: "Returns",
    chains: "Chains",
    stores: "Stores",
    users: "Users",
    logout: "Logout",
    
    // Common
    search: "Search",
    filter: "Filter",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    back: "Back",
    close: "Close",
    yes: "Yes",
    no: "No",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    
    // Greetings
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    goodNight: "Good Night",
    
    // Days
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    
    // Other
    allCategories: "All Categories",
    systemAdmin: "System Administrator",
    areaManager: "Area Manager",
    allNetworks: "All Networks"
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations.he[key] || key;
};